import { ScheduleRepository } from 'repository/schedule/ScheduleRepo';
import { AxiosHttpService } from 'services/AxiosHttpService';
import { createApiClient } from 'utils/AxiosClient';
import { ICacheService } from './ICacheService';
import { CacheService } from 'services/CacheService';
import { ShiftProfileRepository } from 'repository/schedule/ShiftProfileRepo';
import { ShiftProfileGroupRepository } from 'repository/schedule/ShiftProfileGroupRepo';
import { SchedulingRulesRepository } from 'repository/schedule/SchedulingRuleRepo';
import { SchedulingRulesAssignRepository } from 'repository/schedule/SchedulingRuleAssingRepo';

export class ScheduleService {
    private cacheService: ICacheService;
    private httpService: IHttpService;

    public schedule: ScheduleRepository;

    public shift_profile: ShiftProfileRepository;
    public shift_profile_group: ShiftProfileGroupRepository;
    public scheduling_rules: SchedulingRulesRepository;
    public scheduling_rules_assign: SchedulingRulesAssignRepository;

    constructor(url?: string) {
        this.cacheService = new CacheService('tk-cache-db');
        const baseURL = url ? url : `${process.env.REACT_APP_TK_GW_DOMAIN}/v1/schedule`;
        const apiClient = createApiClient(baseURL);
        this.httpService = new AxiosHttpService(apiClient, this.cacheService);

        this.schedule = new ScheduleRepository(this.httpService);
        this.shift_profile = new ShiftProfileRepository(this.httpService);
        this.shift_profile_group = new ShiftProfileGroupRepository(this.httpService);
        this.scheduling_rules = new SchedulingRulesRepository(this.httpService);
        this.scheduling_rules_assign = new SchedulingRulesAssignRepository(this.httpService);
    }
}
